export default "__VITE_ASSET__oTZMjxe5__"